import React, { useState, useEffect } from 'react';
import { AppBar, Avatar, Button, Chip, Divider, Drawer, Grid, IconButton, Input, List, ListItem, ListItemIcon, ListItemText, Menu, MenuItem, TextField, Toolbar, Tooltip, Typography } from '@mui/material';
import { ArrowDropDown, ArrowDropUp, ChevronRight, ChevronLeft, Home, Info, Clear } from '@mui/icons-material';
import * as componentActions from '../../../../redux/actions/chats' // trocar pelo redux que criarei no chat
import { bindActionCreators } from 'redux'
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { connect } from 'react-redux';
import './styles.css'
import EmailIcon from '@mui/icons-material/Email';
import RefreshIcon from '@mui/icons-material/Refresh';
import PhoneIcon from '@mui/icons-material/Phone';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Controller, useForm } from 'react-hook-form';
import { PapiroConsole } from '../../../../utils/papiroConsole';
import SimpleAutoComplete from '../autocomplete';
import SimpleAutoCompleteWithTooltip from '../autocompletewithtooltip';
import useIsMobile from '../../../../hooks/useIsMobile';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ChatLabel from './label/label';
import ChatNote from './note';
import PersonIcon from '@mui/icons-material/Person';
import TitleOutlinedIcon from '@mui/icons-material/TitleOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Api2Talk from "../../../../services/api2talk";
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import { getChatTags } from '../../../../services/2talk/omnichannel';
import ChatTagsEditor from './chat-tags-editor';
import RequesterHistoryDetailsModal from '../../../called-accompaniment/components/requester-history-details-modal';
import CustomerPhoneSyncCard from './customer-phone-sync-card';

const drawerWidth = 230;

function stringToColor(string) {
  let hash = 0
  let i

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash)
  }

  let color = '#'

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff
    color += `00${value.toString(16)}`.slice(-2)
  }
  return color
}

function stringAvatar(name) {
  const safeName = typeof name === 'string' ? name.trim() : '';

  return {
    sx: {
      bgcolor: safeName ? stringToColor(safeName) : undefined,
    },
    children: safeName ? safeName.charAt(0) : undefined,
  }
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: 0,
    borderLeft: 0,
    // Amarra a altura à MESMA var limitada do .omnichannel-main (valor concreto em px).
    // `height: 100%`/`101%` resolvia contra o `height: 100vh` declarado no main (NÃO contra o
    // max-height real) → a sidebar ficava ~100vh, mais alta que o container, o conteúdo cabia
    // e o overflow nunca rolava. Usando a var, a sidebar tem EXATAMENTE a altura visível →
    // quando os blocos (Chamados + Notas) passam disso, a barra de rolagem vertical engata.
    height: 'var(--mexx-main-height, calc(100vh - 156px))',
    maxHeight: 'var(--mexx-main-height, calc(100vh - 156px))',
    backgroundColor: '#F3F3F3',
    color: 'white',
    position: 'relative',
    top: 0,
    right: 0,
    // root é só o container limitado; o scroll ÚNICO mora no wrapper interno (vide `content`).
    // Mantê-lo flex-column + scroll comprimia os blocos (flex-shrink) e espremia a "Notas".
    overflowX: 'hidden',
    overflowY: 'hidden',
    transition: 'border-left,width 0.5s cubic-bezier(0.4, 0, 0.6, 1)',
    padding: 0
  },
  open: {
    borderLeft: '10px solid #DADADA',
    width: '20%',
    '@media (max-width:599.9px)': {
      width: '30%',
      top: '20px',
      height: '116.5%'
    },
    '@media (min-width:600px) and (max-width:1199.9px)': {
      width: '30%',
    },
    '@media (min-width:1200px)': {
      width: '20%',
    }
  },
  gridClose: {
    display: 'none!important'
  },
  gridOpen: {
    display: 'flex!important'
  },
  gridItemCenter: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center'
  },
  gridItemSubtitleColor: {
    color: '#B4B4B4',
    fill: '#B4B4B4'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    position: 'absolute',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    marginLeft: drawerWidth,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentShift: {
    marginLeft: 2 * drawerWidth, // Ajuste conforme necessário
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  toolbar: theme.mixins.toolbar,
  // Pulso da bolinha "Recebendo mensagens" — passa sensação de tempo real (cresce/diminui).
  '@keyframes receivingPulse': {
    '0%': { transform: 'scale(0.7)', opacity: 0.6 },
    '50%': { transform: 'scale(1.3)', opacity: 1 },
    '100%': { transform: 'scale(0.7)', opacity: 0.6 },
  },
  receivingDot: {
    fontSize: '9px !important',
    animation: '$receivingPulse 1.2s ease-in-out infinite',
  },
  '@keyframes spin360': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
  },
  spin: {
    animation: '$spin360 0.8s linear infinite',
  },
}));

function ChatUserDetailsSidebar(props) {
  const { isOpen, onClose, chats, intl } = props
  const customer = chats?.chat?.customer;
  const customerId = customer?.id;
  const showLegacyCustomerSync = chats?.chat?.messageproviderid != null
    && Number(chats.chat.messageproviderid) !== 2;
  const customerName =
    (typeof customer?.name === 'string' ? customer.name.trim() : '') ||
    (customer?.phone != null ? String(customer.phone).trim() : '') ||
    (customerId ? `Cliente #${customerId}` : '');

  // Refresh manual da lista de chamados vinculados (fallback p/ quando o SignalR falhar).
  const [refreshingCalleds, setRefreshingCalleds] = useState(false);
  const handleRefreshLinkedCalleds = async () => {
    if (!props.reloadLinkedCalleds || refreshingCalleds) return;
    setRefreshingCalleds(true);
    try { await props.reloadLinkedCalleds(); } finally { setTimeout(() => setRefreshingCalleds(false), 600); }
  };
  PapiroConsole.log(props)
  PapiroConsole.log("props da nota aqui")
  const classes = useStyles();
  // Detecção centralizada de mobile (<=599.95px). Quando true, a sidebar deixa de ser
  // permanente (com width:0 → width:30% e height:116.5% que vazava) e vira um Drawer
  // temporary com backdrop — comportamento padrão Material em viewports compactas.
  const isMobile = useIsMobile();

  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [editChatDetails, setEditChatDetails] = React.useState(false)
  const [chatDetailsPriorityList, setChatDetailsPriorityList] = React.useState(props.priorityList ? props.priorityList : [] ) // Substituir pela lista da API
  const [chatDetailsCategoryList, setChatDetailsCategoryList] = React.useState(props.categoryList ? props.categoryList : []) // Substituir pela lista da API
  const [chatDetailsDepartamentList, setChatDetailsDepartamentList] = React.useState(props.departamentList ? props.departamentList : []) // Substituir pela lista da API
  //const [chatDetailsAssignedUserList, setChatDetailsAssignedUserList] = React.useState([{ id: 1, name: 'Pessoa' }]) // Substituir pela lista da API
  const [chatDetailsOrganizationList, setChatDetailsOrganizationList] = React.useState(props.organizationList ? props.organizationList : []) // Substituir pela lista da API
  const [chatDetailsAddressList, setChatDetailsAddressList] = React.useState(props.addressList ? props.addressList : []) // Substituir pela lista da API

  const { control: chatDetailsControl, handleSubmit: chatDetailsHandleSubmit, setValue : setValueChatDetails } = useForm({
    defaultValues: {
      title: chats && chats.chat && chats.chat.title ? chats.chat.title : '',
      //assigneduser: chats && chats.chat && chats.chat.assignedusername ? chats.chat.assignedusername : '',
      organization : chats && chats.chat && chats.chat.organization ? chats.chat.organization : null,
      priority: chats && chats.chat && chats.chat.priority ? chats.chat.priority : null,
      category: chats && chats.chat && chats.chat.organizationcategory ? chats.chat.organizationcategory : null,
      departament: chats && chats.chat && chats.chat.organizationdepartament ? chats.chat.organizationdepartament : null,
      address: chats && chats.chat && chats.chat.address ? chats.chat.address : null,
    },
  })

  const changeValues = (stateName, value) => {

      PapiroConsole.log(stateName)
      PapiroConsole.log(value)
      PapiroConsole.log("stateName,value")

      if(stateName == "organization"){
            if(value && value.id != 0){
              props.getCategoriesByOrganizationId(value.id);
              props.getOrganizationsDepartamentsByOrganizationId(value.id)
              props.getAddressesByOrganizationId(value.id)
            }
            else{
              setChatDetailsCategoryList([]);
              setChatDetailsDepartamentList([]);
              setChatDetailsAddressList([]);
              setValueChatDetails('category', ({id:0, name:''}));
              setValueChatDetails('departament', ({id:0, name:''}));
              setValueChatDetails('address',({id:0, name:''}));
            }
            
      }

  };


  const handleShowEditChatDetails = _ => {
    setEditChatDetails(!editChatDetails)
  }

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  const syncCustomerData = () => {
    handleMenuClose();
    props.openOrCloseDialogSyncDataModal();
  };

  // Chamados vinculados (FASE 1: mock via props). O primeiro item é o "ativo" — quem
  // recebe as novas mensagens da conversa como acompanhamento.
  const linkedCalledList = props.linkedCalledList || []
  const lang = (window.location.pathname.split('/')[1]) || 'pt'
  const openCalledInNewTab = (id) => window.open(`/${lang}/called-accompaniment/${id}`, '_blank')

  // Modal de detalhes do chamado (reaproveitado da tela "Minha Pauta" / agent-workspace):
  // abre os dados do chamado sem sair da conversa. O modal busca os dados sozinho pelo id.
  const [calledDetailItem, setCalledDetailItem] = useState(null)
  const openCalledDetail = (called) => setCalledDetailItem({
    id: called.calledId,
    type: 'called',
    calledId: called.calledId,
    title: called.title || '',
    displayTitle: called.title || ''
  })
  const closeCalledDetail = () => setCalledDetailItem(null)
  

  const [editChatUserDetails, setEditChatUserDetails] = React.useState(false)
  // Tags da conversa (chips read-only na seção "Tags da conversa").
  const [chatTagsList, setChatTagsList] = useState([])
  const { control: chatUserDetailsControl, handleSubmit: chatUserDetailsHandleSubmit, setValue } = useForm({
    defaultValues: {
      name: (chats && chats.chat && chats.chat.customer && chats.chat.customer.name) ? chats.chat.customer.name : "",
      email: (chats && chats.chat && chats.chat.customer && chats.chat.customer.email) ? chats.chat.customer.email : "",
      phone: (chats && chats.chat && chats.chat.customer && chats.chat.customer.phone) ? chats.chat.customer.phone : ""
    },
  })

  //atualizar valores do sobre depois de atualizado
  useEffect(() => {
    

    setValueChatDetails('title', (chats && chats.chat && chats.chat.title ? chats.chat.title :''));
    setValueChatDetails('organization', (chats && chats.chat && chats.chat.organization) ? chats.chat.organization :  {id : 0, name: ''});
    setValueChatDetails('priority', (chats && chats.chat && chats.chat.priority) ? chats.chat.priority :  {id : 0, name: ''});
    setValueChatDetails('category', (chats && chats.chat && chats.chat.organizationcategory) ? chats.chat.organizationcategory :  {id : 0, name: ''});
    setValueChatDetails('departament', (chats && chats.chat && chats.chat.organizationdepartament) ? chats.chat.organizationdepartament :  {id : 0, name: ''});
    setValueChatDetails('address',(chats && chats.chat && chats.chat.address) ? chats.chat.address : {id : 0, name: ''})
  }, [chats && chats.chat && chats.chat.title, chats && chats.chat && chats && chats.chat.organization, chats && chats.chat && chats.chat.priority, chats && chats.chat && chats.chat.category, chats && chats.chat && chats.chat.organizationdepartament, chats && chats.chat && chats.chat.address ]);

  useEffect(() => {

    setValue('name', (chats && chats.chat && chats.chat.customer && chats.chat.customer.name) ? chats.chat.customer.name : "");
    setValue('email', (chats && chats.chat && chats.chat.customer && chats.chat.customer.email) ? chats.chat.customer.email : "");
    setValue('phone', (chats && chats.chat && chats.chat.customer && chats.chat.customer.phone) ? chats.chat.customer.phone : "");
  }, [chats && chats.chat && chats.chat.customer && chats.chat.customer.name, setValue]);

  // Carrega/recarrega as tags da conversa (mount/troca de chat e após add/remove no editor).
  // Promise chain (sem async/await em arrow — babel 7.12.3 do react-scripts 4).
  const loadChatTags = (chatId) => {
    if (!chatId) { setChatTagsList([]); return; }
    getChatTags(chatId)
      .then(result => {
        if (result && result.success && Array.isArray(result.data)) setChatTagsList(result.data);
        else setChatTagsList([]);
      })
      .catch(() => setChatTagsList([]));
  };

  useEffect(() => {
    loadChatTags(chats && chats.chat && chats.chat.id ? chats.chat.id : null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chats && chats.chat && chats.chat.id]);

 


  //atualizar valores dos autocompletes
  useEffect(() => {
    
    if (props.priorityList && props.priorityList !== chatDetailsPriorityList ) {
      setChatDetailsPriorityList(props.priorityList);
    }

 
    if (props.organizationList && props.organizationList !== chatDetailsOrganizationList) {
      setChatDetailsOrganizationList(props.organizationList);
    }
    if (props.organizationCategoryList && props.organizationCategoryList !== chatDetailsCategoryList) {
      setChatDetailsCategoryList(props.organizationCategoryList);
    }
    if (props.organizationDepartamentList && props.organizationDepartamentList !== chatDetailsDepartamentList) {
      setChatDetailsDepartamentList(props.organizationDepartamentList);
    }
    if(props.addressList && props.addressList !== chatDetailsAddressList){
      setChatDetailsAddressList(props.addressList);
    }
  }, [props.priorityList, props.organizationList, props.organizationCategoryList, props.organizationDepartamentList, props.addressList]);

  const handleShowEditChatUserDetails = _ => {
    setEditChatUserDetails(!editChatUserDetails)
  }
  const validations = (data) => {
    let result = true;

    for (let element in data) {
      PapiroConsole.log(element)
      PapiroConsole.log(data[element])
      PapiroConsole.log("Dados aqui")
      if (data[element] == null || data[element] == '') {
        if (element == 'name') {

          props.setNotificationMessage("Campo Nome é obrigatório");

        }
        else if (element == 'email') {

          props.setNotificationMessage("Campo E-mail é obrigatório");

        }
        else if (element == 'phone') {

          props.setNotificationMessage("Campo Telefone é obrigatório");
        }

        props.setLoading(false);
        props.setOpenNotification(true);
        props.setNotificationVariant("error");
        return false
      }
    };

    return true;


  }

  const findNameOfValue = (list, value) => {
    if (list && list.length > 0 && value && value.id) {
      const item = list.find(i => i.id == value.id);
      return item ? item.name : '';
    }
    return '';
  }

  const onSubmitEditChatUserDetails = (data) => {

    props.setLoading(true);
    //var validation = validations(data)

      data.id = chats && chats.chat && chats.chat.customer && chats.chat.customer.id ? chats.chat.customer.id : 0
      data.chatid = chats && chats.chat && chats.chat.id ? chats.chat.id : 0
      data.chatmessageproviderid = chats.chat.messageproviderid ; 
      Api2Talk.put('customer/updateuserinfos', data)
        .then((result) => {
          if (result.data.success) {
            PapiroConsole.log("result aqui depois do submit")
            PapiroConsole.log(result)
            if (result.data && result.data.data) {
              props.updateUserInformations(result.data.data, chats.chat.id)
              setEditChatUserDetails(false)

              props.setLoading(false);
              props.setOpenNotification(true);
              props.setNotificationMessage("Suas informações foram atualizadas com sucesso");
              props.setNotificationVariant("success");



            }

          } else {
            props.setLoading(false);
            props.setOpenNotification(true);
            props.setNotificationMessage("Erro ao processar a solicitação.");
            props.setNotificationVariant("error");
          }
        })
        .catch((err) => {
          PapiroConsole.log(err)
          PapiroConsole.log("err")
          if (err.response && err.response.data && err.response.data.errors) {
            props.setLoading(false);
            props.setOpenNotification(true);
            props.setNotificationMessage(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : "Erro ao processar a solicitação.");
            props.setNotificationVariant("error");


          } else {
            props.setLoading(false);
            props.setOpenNotification(true);
            props.setNotificationMessage(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : "Erro ao processar a solicitação.");
            props.setNotificationVariant("error");
          }
        });
      PapiroConsole.log(data)
      PapiroConsole.log("data aqui")
    

  }

  const onSubmitEditChatDetails = (data) => {

    PapiroConsole.log(data)
    PapiroConsole.log("data informado")
    props.setLoading(true);

    let sentData = {
      categoryId : data.category  && data.category.id != 0  ? data.category.id : null,
      departamentId : data.departament && data.departament.id != 0 ? data.departament.id : null,
      organizationId : data.organization  && data.organization.id != 0  ? data.organization.id : null,
      priorityId : data.priority &&  data.priority.id != 0 ? data.priority.id : null,
      title : data.title ? data.title : null,
      addressId : data.address && data.address.id !== 0 ? data.address.id : null
      
    }
    PapiroConsole.log(sentData.departamentId)
    PapiroConsole.log("sentData.departamentId")
    sentData.chatid = chats && chats.chat && chats.chat.id ? chats.chat.id : 0
    Api2Talk.put('chat/updatechatdetails', sentData)
      .then((result) => {
        if (result.data.success) {
          PapiroConsole.log("result aqui depois do submit")
          PapiroConsole.log(result)
          if (result.data && result.data.data) {
            
            //props.updateUserInformations(result.data.data, chats.chat.id)
            //setEditChatUserDetails(false)
            props.updateUserDetailsInformations(result.data.data, chats.chat.id)
            PapiroConsole.log(result.data.data)
           // props.setEditChatUserDetails(false);

            props.setLoading(false);
            props.setOpenNotification(true);
            props.setNotificationMessage("Suas informações foram atualizadas com sucesso");
            props.setNotificationVariant("success");



          }

        } else {
          props.setLoading(false);
          props.setOpenNotification(true);
          props.setNotificationMessage("Erro ao processar a solicitação.");
          props.setNotificationVariant("error");
        }
      })
      .catch((err) => {
        PapiroConsole.log(err)
        PapiroConsole.log("err")
        if (err.response && err.response.data && err.response.data.errors) {
          props.setLoading(false);
          props.setOpenNotification(true);
          props.setNotificationMessage(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : "Erro ao processar a solicitação.");
          props.setNotificationVariant("error");


        } else {
          props.setLoading(false);
          props.setOpenNotification(true);
          props.setNotificationMessage(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : "Erro ao processar a solicitação.");
          props.setNotificationVariant("error");
        }
      });
    PapiroConsole.log(data)
    PapiroConsole.log("data aqui")


  }
  
  

  PapiroConsole.log("=== ChatUserDetailsSidebar -> intl ===")
  PapiroConsole.log(intl)
  PapiroConsole.log(props)
  PapiroConsole.log(chatUserDetailsControl)

  /* Legacy direct request replaced by the confirmation modal flow.
     let data = {
       //id : chats && chats.chat && chats.chat.customer && chats.chat.customer.id ? chats.chat.customer.id : 0,
       //chatid : chats && chats.chat && chats.chat.id ? chats.chat.id : 0,
       name: (chats && chats.chat && chats.chat.customer && chats.chat.customer.name) ? chats.chat.customer.name : "",
       email: (chats && chats.chat && chats.chat.customer && chats.chat.customer.email) ? chats.chat.customer.email : "",
       phone: (chats && chats.chat && chats.chat.customer && chats.chat.customer.phone) ? chats.chat.customer.phone : ""
 
     }
     var validation = validations(data)
     data.id = chats && chats.chat && chats.chat.customer && chats.chat.customer.id ? chats.chat.customer.id : 0
     data.chatid = chats && chats.chat && chats.chat.id ? chats.chat.id : 0
     
     props.setLoading(true);
 
     if (validation) {
 
       Api2Talk.put('customer/syncdata', data)
         .then((result) => {
           if (result.data.success) {
             PapiroConsole.log("result aqui depois do submit")
             PapiroConsole.log(result)
             if (result.data && result.data.data) {
              
               setEditChatUserDetails(false)
               props.setLoading(false);
               props.setOpenNotification(true);
               props.setNotificationMessage("Suas informações foram atualizadas com Sucesso");
               props.setNotificationVariant("success");
 
             }
 
           } else {
             props.setLoading(false);
             props.setOpenNotification(true);
             props.setNotificationMessage("Erro ao processar a solicitação.");
             props.setNotificationVariant("error");
           }
         })
         .catch((err) => {
           PapiroConsole.log(err)
           PapiroConsole.log("err")
           if (err.response && err.response.data && err.response.data.errors) {
             props.setLoading(false);
             props.setOpenNotification(true);
             props.setNotificationMessage(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : "Erro ao processar a solicitação.");
             props.setNotificationVariant("error");
 
 
           } else {
             props.setLoading(false);
             props.setOpenNotification(true);
             props.setNotificationMessage(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : "Erro ao processar a solicitação.");
             props.setNotificationVariant("error");
           }
         });
       PapiroConsole.log(data)
       PapiroConsole.log("data aqui")
     }
  */


  if (customerId) {
    // Conteúdo extraído num fragment p/ ser embrulhado por: <Drawer> em mobile
    // OU pelo <div className={classes.root + classes.open}> tradicional em desktop.
    // Isso preserva 100% do markup original — só muda o wrapper externo conforme a viewport.
    const content = (
      <>
        {/* Barra de rolagem ÚNICA p/ Sobre / Chat / Chamados Associados / Notas (e header).
            BLOCK flow de propósito (sem display:flex): os `Grid container` precisam do width:100%
            do fluxo normal — flex aqui quebrava os campos em linha. `overflowX:hidden` mata a barra
            horizontal (as margens negativas do Grid spacing senão estouram quando overflow-y=auto).
            `flex:1; minHeight:0` faz o wrapper ocupar a altura do root (limitado pela var) e rolar. */}
        <div style={{ flex: '1 1 auto', minHeight: 0, overflowY: 'auto', overflowX: 'hidden', paddingBottom: 12 }}>
        <Grid className={`${isOpen ? classes.gridOpen : classes.gridClose}`} sx={{ padding: '3%', paddingTop: '20px' }} container spacing={0}>
          {/* Header: em desktop (sm+) avatar 17% / nome 67% / menu 8% / close 8% — uma linha.
              `paddingTop: 20px` espelha o `paddingTop: 10%` que o chat-history-sidebar já tinha —
              sem isso o avatar (56px circle) ficava colado no topo da sidebar desktop, sendo cortado.
              Antes em mobile (xs) tinha xs={12} no avatar e xs={12} no nome → quebrava em 3 linhas
              (3% padding × 3 ≈ 18% de altura desperdiçados, e o close ficava embaixo, longe do alvo
              esperado pelo dedo). Agora xs={2}/{6}/{2}/{2} mantém tudo em uma linha — compactação
              de Zendesk/Movidesk em sidebars mobile. */}
          {/* Header em flexbox: avatar fixo (não encolhe), nome flexível com ellipsis NO FIM (e
              title pro nome completo no hover), ícones fixos. Antes era Grid 12-col + justify center,
              o que centralizava o nome (cortava dos DOIS lados) e o avatar de 56px transbordava a
              coluna xs={2} ficando por cima do nome. */}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div style={{ display: 'flex', alignItems: 'center', width: '100%', gap: 8 }}>
              {customerName && <Avatar
                sx={{ width: 56, height: 56, flexShrink: 0 }}
                {...stringAvatar(customerName)} />}
              <Tooltip title={`${chats.chat.title ? chats.chat.title + ' - ' : ''}${customerName}`} arrow>
                <div
                  className='omnichannel-chat-user-details-sidebar-header'
                  style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {chats.chat.title ? chats.chat.title + ' - ' : ''}{customerName}
                </div>
              </Tooltip>
              {showLegacyCustomerSync && (
                <>
                  <IconButton onClick={handleMenuOpen} style={{ flexShrink: 0 }}>
                    {menuOpen ? <ArrowDropUp /> : <ArrowDropDown />}
                  </IconButton>
                  <Menu
                    anchorEl={anchorEl}
                    open={menuOpen}
                    onClose={handleMenuClose}
                  >
                    <MenuItem onClick={syncCustomerData}>
                      {intl.formatMessage({ id: "chatdetails.syncdata" })}
                    </MenuItem>
                  </Menu>
                </>
              )}
              <IconButton onClick={onClose} style={{ flexShrink: 0 }}>
                <Clear />
              </IconButton>
            </div>
          </Grid>

        </Grid>
        <Divider className={`${isOpen ? classes.gridOpen : classes.gridClose}`} />
        <Grid className={`omnichannel-chat-user-details-sidebar-about ${isOpen ? classes.gridOpen : classes.gridClose}`} sx={{ padding: '3%' }} container spacing={0}>
          <Grid className='omnichannel-chat-user-details-sidebar-header' item xs={12} sm={8} md={9} lg={9} xl={9} >
            {intl.formatMessage({ id: "chatdetails.about" })}
          </Grid>
          <Grid className={`${classes.gridItemSubtitleColor}`} item xs={12} sm={4} md={3} lg={3} xl={3} style={{ display: 'flex', justifyContent: 'flex-end' }} >
            {!editChatUserDetails && <Button variant="outlined"
              size="small"
              style={{ textTransform: 'none' }}
              onClick={handleShowEditChatUserDetails}>
              {intl.formatMessage({ id: "edit" })}
            </Button>}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {!editChatUserDetails && <Grid container spacing={0}>
              <Grid item xs={1} sm={1} md={1} lg={1} xl={1} />
              <Grid className={`${classes.gridItemSubtitleColor}`} item xs={1} sm={1} md={1} lg={1} xl={1} >
                <PersonIcon />
              </Grid>
              <Grid className={`${classes.gridItemSubtitleColor}`} sx={{ paddingLeft: '5px' }} item xs={10} sm={10} md={10} lg={10} xl={10} >
                {customerName}
              </Grid>
              <Grid item xs={1} sm={1} md={1} lg={1} xl={1} />
              <Grid className={`${classes.gridItemSubtitleColor}`} item xs={1} sm={1} md={1} lg={1} xl={1} >
                <PhoneIcon />
              </Grid>
              <Grid className={`${classes.gridItemSubtitleColor}`} sx={{ paddingLeft: '5px' }} item xs={10} sm={10} md={10} lg={10} xl={10} >
                {chats.chat.customer.phone ? chats.chat.customer.phone : ''}
              </Grid>

              <Grid item xs={1} sm={1} md={1} lg={1} xl={1} />
              <Grid className={`${classes.gridItemSubtitleColor}`} item xs={1} sm={1} md={1} lg={1} xl={1} >
                <EmailIcon />
              </Grid>
              <Grid className={`${classes.gridItemSubtitleColor}`} sx={{ paddingLeft: '5px' }} item xs={10} sm={10} md={10} lg={10} xl={10} >
                {chats.chat.customer.email ? chats.chat.customer.email : ''}
              </Grid>
            </Grid>}
            {editChatUserDetails && <form onSubmit={chatUserDetailsHandleSubmit(onSubmitEditChatUserDetails)}><Grid container spacing={2} style={{ padding: '5%' }}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Controller
                  name="name"
                  control={chatUserDetailsControl}
                  variant='outlined'
                  render={({ field }) => <TextField fullWidth required label={`${intl.formatMessage({ id: "name" })}`} {...field} />} />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Controller
                  name="email"
                  control={chatUserDetailsControl}
                  variant='outlined'
                  
                  render={({ field }) => <TextField disabled={props.chats.chat.messageproviderid == 6 ? true : false} fullWidth required={props.chats.chat.messageproviderid == 6 ? true : false} label={`${intl.formatMessage({ id: "email" })}`} {...field} />} />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Controller
                  name="phone"
                  control={chatUserDetailsControl}
                  variant='outlined'

                  render={({ field }) => <TextField disabled={props.chats.chat.messageproviderid == 2 ? true : false} fullWidth required={props.chats.chat.messageproviderid == 2 ? true : false} label={`${intl.formatMessage({ id: "phone" })}`} {...field} />} />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={2} xl={4} />
                  {/* xs={6} (era xs={12}) pra Cancelar e Salvar dividirem a mesma linha em mobile.
                      Antes empilhavam (3 linhas com o spacer acima). Agora: spacer xs={12} full row
                      vazia + Cancelar 50% / Salvar 50% lado a lado. Demais breakpoints intactos. */}
                  <Grid item xs={6} sm={12} md={6} lg={5} xl={4} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                    <Button variant="outlined"
                      size="small"
                      style={{ textTransform: 'none' }}
                      onClick={handleShowEditChatUserDetails}>
                      <FormattedMessage id="cancel" />
                    </Button>
                  </Grid>
                  <Grid item xs={6} sm={12} md={6} lg={5} xl={4} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                    <Button variant="contained"
                      type="submit"
                      size="small"
                      style={{ textTransform: 'none' }}>
                      <FormattedMessage id="save" />
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid></form>}
          </Grid>
        </Grid>
        <CustomerPhoneSyncCard
          isOpen={isOpen}
          chat={chats.chat}
          intl={intl}
          updateCurrentChatCustomerData={props.updateCurrentChatCustomerData}
          setGlobalLoading={props.setLoading}
          setNotificationMessage={props.setNotificationMessage}
          setNotificationVariant={props.setNotificationVariant}
          setOpenNotification={props.setOpenNotification}
        />
        <Divider className={`${isOpen ? classes.gridOpen : classes.gridClose}`} />
        <Grid className={`omnichannel-chat-user-details-sidebar-chat ${isOpen ? classes.gridOpen : classes.gridClose}`} sx={{ padding: '3%' }} container spacing={0}>
          <Grid className='omnichannel-chat-user-details-sidebar-header' item xs={12} sm={8} md={9} lg={9} xl={9} >
            {intl.formatMessage({ id: "chatdetails.chat" })}
          </Grid>
          <Grid className={`${classes.gridItemSubtitleColor}`} item xs={12} sm={4} md={3} lg={3} xl={3} style={{ display: 'flex', justifyContent: 'flex-end' }} >
            {!editChatDetails && <Button variant="outlined"
              size="small"
              style={{ textTransform: 'none' }}
              onClick={handleShowEditChatDetails}>
              {intl.formatMessage({ id: "edit" })}
            </Button>}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {!editChatDetails && (() => {
              // ----- Layout sênior: ícone | label · valor — mantém estética discreta atual -----
              const emptyMark = <span style={{ color: '#bbb' }}>—</span>;
              const rowStyle = { display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0' };
              const iconStyle = { color: '#9e9e9e', fontSize: 18, flexShrink: 0 };
              const labelStyle = { color: '#888', fontSize: 12, fontWeight: 500, minWidth: 90, flexShrink: 0 };
              const valueStyle = { color: '#222', fontSize: 13, fontWeight: 500, wordBreak: 'break-word' };

              const channelExtraLabel =
                chats.chat.messageproviderid == 6 && chats.chat.webchatid ? intl.formatMessage({ id: "chatdetails.webchat" }) :
                chats.chat.messageproviderid == 2 && chats.chat.registrationnumberrequestid ? intl.formatMessage({ id: "chatdetails.phoneregistration" }) : null;
              const channelExtraValue =
                chats.chat.messageproviderid == 6 && chats.chat.webchatid ? chats.chat.webchatid :
                chats.chat.messageproviderid == 2 && chats.chat.registrationnumberrequestid ? chats.chat.registrationnumberrequestid : null;

              const rows = [
                { icon: <TitleOutlinedIcon style={iconStyle} />,         label: intl.formatMessage({ id: "title" }),                    value: chats.chat.title },
                { icon: <BusinessOutlinedIcon style={iconStyle} />,      label: intl.formatMessage({ id: "organization" }),             value: (chats.chat.organization && chats.chat.organization.name) ? chats.chat.organization.name : null },
                { icon: <AssignmentIndOutlinedIcon style={iconStyle} />, label: intl.formatMessage({ id: "chatdetails.responsible" }),  value: chats.chat.assignedusername },
                { icon: <FlagOutlinedIcon style={iconStyle} />,          label: intl.formatMessage({ id: "priority" }),                 value: chats.chat.priority && chats.chat.priority.name },
                { icon: <CategoryOutlinedIcon style={iconStyle} />,      label: intl.formatMessage({ id: "category" }),                 value: chats.chat.organizationcategory ? (chats.chat.organizationcategory.parentname || chats.chat.organizationcategory.name) : null },
                { icon: <ApartmentOutlinedIcon style={iconStyle} />,     label: intl.formatMessage({ id: "chatdetails.department" }),    value: chats.chat.organizationdepartament && chats.chat.organizationdepartament.name },
                { icon: <HubOutlinedIcon style={iconStyle} />,           label: intl.formatMessage({ id: "chatdetails.channel" }),      value: (chats.chat.channelid && chats.chat.channelname) ? chats.chat.channelname : null },
              ];

              if (channelExtraLabel) {
                rows.push({ icon: <LinkOutlinedIcon style={iconStyle} />, label: channelExtraLabel, value: channelExtraValue });
              }

              return (
                <div style={{ padding: '4px 6px 0 6px' }}>
                  {rows.map((r, i) => (
                    <div key={i} style={rowStyle}>
                      {r.icon}
                      <span style={labelStyle}>{r.label}</span>
                      <span style={valueStyle}>{(r.value !== null && r.value !== undefined && r.value !== '') ? r.value : emptyMark}</span>
                    </div>
                  ))}
                </div>
              );
            })()}
            {editChatDetails && <form onSubmit={chatDetailsHandleSubmit(onSubmitEditChatDetails)}>
              <Grid container spacing={2} style={{ padding: '5%' }}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Controller
                    name="title"
                    control={chatDetailsControl}
                    variant='outlined'
                    render={({ field }) => <TextField fullWidth  label={`${intl.formatMessage({ id: "title" })}`} {...field} />} />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Controller
                    name="organization"
                    control={chatDetailsControl}
                    stateName="organization"
                    render={({ field }) => (
                      <SimpleAutoComplete
                        {...field}
                        expandPopper
                        label={intl.formatMessage({ id: "organization" })}
                        options={chatDetailsOrganizationList}
                        selected={field.value}
                        
                        
                        changeSelect={changeValues}
                        stateName="organization"
                      />
                    )} />
                    </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Controller
                      name="address"
                      control={chatDetailsControl}
                      stateName="address"
                      render={({ field }) => (
                        <SimpleAutoComplete
                          {...field}
                          expandPopper
                          label={intl.formatMessage({ id: "location" })}
                          options={chatDetailsAddressList}
                          selected={field.value}        
                          changeSelect={changeValues}
                          stateName="address"
                        />
                      )} />
                  </Grid>
                {/*<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Controller
                    name="assigneduser"
                    control={chatDetailsControl}
                    stateName="assigneduser"
                    render={({ field }) => (
                      <SimpleAutoComplete
                        {...field}
                        expandPopper
                        label={intl.formatMessage({ id: "attr.to" })}
                        options={chatDetailsAssignedUserList}
                        selected={field.value}
                        isRequired
                        required
                      />
                    )} />
                    </Grid>*/}
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Controller
                    name="priority"
                    control={chatDetailsControl}
                    stateName="priority"
                    render={({ field }) => (
                      <SimpleAutoComplete
                        {...field}
                        expandPopper
                        label={intl.formatMessage({ id: "priority" })}
                        options={chatDetailsPriorityList}
                        selected={field.value}
                        //changeSelect={changeValues}
                        
                        
                      />
                    )} />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Controller
                    name="category"
                    control={chatDetailsControl}
                    render={({ field }) => (
                      <SimpleAutoCompleteWithTooltip
                        {...field}
                        expandPopper
                        stateName="category"
                        label={intl.formatMessage({ id: "category" })}
                        options={chatDetailsCategoryList}
                        selected={field.value}
                      />
                    )} />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Controller
                    name="departament"
                    control={chatDetailsControl}
                    render={({ field }) => (
                      <SimpleAutoComplete
                        {...field}
                        expandPopper
                        stateName="departament"
                        label={intl.formatMessage({ id: "departament" })}
                        options={chatDetailsDepartamentList}
                        selected={field.value}
                        
                        
                      />
                    )} />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={2} xl={4} />
                    {/* xs={6} pra Cancelar/Salvar lado a lado em mobile (vide form do Sobre acima). */}
                    <Grid item xs={6} sm={12} md={6} lg={5} xl={4} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                      <Button variant="outlined"
                        size="small"
                        style={{ textTransform: 'none' }}
                        onClick={handleShowEditChatDetails}>
                        <FormattedMessage id="cancel" />
                      </Button>
                    </Grid>
                    <Grid item xs={6} sm={12} md={6} lg={5} xl={4} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                      <Button variant="contained"
                        type="submit"
                        style={{ textTransform: 'none' }}
                        size="small">
                        <FormattedMessage id="save" />
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>}
          </Grid>
        </Grid>
        <Divider className={`${isOpen ? classes.gridOpen : classes.gridClose}`} />
        <Grid className={`omnichannel-chat-user-details-sidebar-calleds ${isOpen ? classes.gridOpen : classes.gridClose}`} sx={{ padding: '3%' }} container spacing={0}>
          <Grid className='omnichannel-chat-user-details-sidebar-header' item xs={12} sm={12} md={12} lg={12} xl={12} >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <span>{intl.formatMessage({ id: "linked.calleds.title" })}</span>
              <Tooltip title={intl.formatMessage({ id: "linked.calleds.refresh" })} arrow>
                <span>
                  <IconButton size="small" onClick={handleRefreshLinkedCalleds} disabled={refreshingCalleds} style={{ color: '#607d8b', padding: 4 }}>
                    <RefreshIcon style={{ fontSize: 18 }} className={refreshingCalleds ? classes.spin : undefined} />
                  </IconButton>
                </span>
              </Tooltip>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ marginTop: 8 }}>
            {(linkedCalledList && linkedCalledList.length > 0) ? (
              linkedCalledList.map((called, index) => (
                <div
                  key={called.id}
                  style={{
                    display: 'flex', flexDirection: 'column', gap: 4,
                    padding: '10px 12px', marginBottom: 8,
                    border: '1px solid #ececec',
                    borderLeft: called.isLatest ? '3px solid #8BC34A' : '3px solid #ececec',
                    borderRadius: '10px', backgroundColor: '#fff',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.04)'
                  }}
                >
                  {/* Linha 1: ícone + info + ações (detalhes / abrir em nova aba). */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%' }}>
                    <div style={{
                      width: 34, height: 34, borderRadius: '8px', flexShrink: 0,
                      backgroundColor: called.isLatest ? '#f1f8e9' : '#f5f5f5',
                      display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}>
                      <ConfirmationNumberOutlinedIcon style={{ fontSize: 18, color: called.isLatest ? '#689F38' : '#90a4ae' }} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
                      <span style={{ fontSize: 14, fontWeight: 600, color: '#607d8b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        #{called.calledId}
                      </span>
                      {called.isLatest && (
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11, color: '#689F38', fontWeight: 600, marginTop: 2 }}>
                          <FiberManualRecordIcon className={classes.receivingDot} />
                          {intl.formatMessage({ id: "linked.calleds.receiving" })}
                        </span>
                      )}
                    </div>
                    <Tooltip title={intl.formatMessage({ id: "linked.calleds.open.details" })} arrow>
                      <IconButton size="small" onClick={() => openCalledDetail(called)} style={{ color: '#277afe' }}>
                        <VisibilityOutlinedIcon style={{ fontSize: 18 }} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={intl.formatMessage({ id: "linked.calleds.open.new.tab" })} arrow>
                      <IconButton size="small" onClick={() => openCalledInNewTab(called.calledId)} style={{ color: '#90a4ae' }}>
                        <OpenInNewIcon style={{ fontSize: 16 }} />
                      </IconButton>
                    </Tooltip>
                  </div>
                  {/* Linha 2 (só quando sem responsável): auto-atribuição, alinhada à direita — não briga
                      por espaço com as ações acima (antes um 3º botão na mesma linha quebrava o card). */}
                  {!called.assignedUserId && (
                    <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                      <Tooltip title={intl.formatMessage({ id: "self.assign.tooltip" })} arrow>
                        <Button size="small"
                          onClick={() => props.onSelfAssignCalled && props.onSelfAssignCalled(called.calledId)}
                          startIcon={<PersonAddAlt1Icon style={{ fontSize: 16 }} />}
                          style={{ textTransform: 'none', color: '#ff9800', fontSize: 12, minWidth: 0, padding: '2px 8px' }}>
                          {intl.formatMessage({ id: "self.assign.confirm" })}
                        </Button>
                      </Tooltip>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div style={{ textAlign: 'center', padding: '20px 8px' }}>
                <div style={{ width: 52, height: 52, borderRadius: '50%', backgroundColor: '#f5f5f5', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
                  <ConfirmationNumberOutlinedIcon style={{ fontSize: 26, color: '#bdbdbd' }} />
                </div>
                <Typography style={{ fontSize: 13, color: '#90a4ae' }}>
                  {intl.formatMessage({ id: "linked.calleds.empty" })}
                </Typography>
              </div>
            )}
          </Grid>
        </Grid>
        {/* Tags da conversa (tb_2talk_chat_tags) — classificação editável (add/remove on-the-fly). */}
        <Divider className={`${isOpen ? classes.gridOpen : classes.gridClose}`} />
        <Grid className={`omnichannel-chat-user-details-sidebar-labels ${isOpen ? classes.gridOpen : classes.gridClose}`} sx={{ padding: '3%' }} container spacing={0}>
          <Grid className='omnichannel-chat-user-details-sidebar-header' item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <LocalOfferOutlinedIcon style={{ fontSize: 18, color: '#607d8b' }} />
              <span>{intl.formatMessage({ id: "chat.tags.title" })}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ marginTop: 8 }}>
            <ChatTagsEditor
              chatId={chats && chats.chat ? chats.chat.id : null}
              tags={chatTagsList}
              onChanged={() => loadChatTags(chats && chats.chat ? chats.chat.id : null)}
              intl={intl}
            />
          </Grid>
        </Grid>
        {/*<Divider className={`${isOpen ? classes.gridOpen : classes.gridClose}`} />
        <Grid className={`omnichannel-chat-user-details-sidebar-labels ${isOpen ? classes.gridOpen : classes.gridClose}`} sx={{ padding: '3%' }} container spacing={0}>
          <Grid className='omnichannel-chat-user-details-sidebar-header' item xs={6} sm={7} md={8} lg={8} xl={8} >
            Rótulos
          </Grid>
          <Grid className={`${classes.gridItemSubtitleColor}`} item xs={6} sm={5} md={4} lg={4} xl={4} style={{ display: 'flex', justifyContent: 'flex-end' }} >
            <Button variant="outlined"
              style={{ textTransform: 'none' }}
              size="small" >
              Gerenciar
            </Button>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ marginTop: 5 }} >
            <Button variant="contained"
              size="small"
              style={{ backgroundColor: '#F2F4F7', textTransform: 'none', color: '#000' }}
              startIcon={<AddCircleIcon style={{ color: '#0088FF', fill: '#0088FF' }} />} >
              Adicionar rótulo
            </Button>
          </Grid>
          <Grid className={`${classes.gridItemSubtitleColor}`} item xs={12} sm={12} md={12} lg={12} xl={12} style={{ marginTop: 5 }} >
            Sugestões de rótulos
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ marginTop: 5 }} >
            <ChatLabel label="Novo cliente"
              checked={false}
              variant="success" />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ marginTop: 5 }} >
            <ChatLabel label="Data de hoje (11/24)"
              checked={false}
              variant="info" />
          </Grid>
                    </Grid>*/}
        <Divider className={`${isOpen ? classes.gridOpen : classes.gridClose}`} />
        <Grid className={`omnichannel-chat-user-details-sidebar-notes ${isOpen ? classes.gridOpen : classes.gridClose}`} sx={{ padding: '3%' }} container spacing={0}>
          {/* Mobile: Notas (xs={5}) + Adicionar nota (xs={7}) na mesma linha, mesmo padrão de sm+.
              Antes era xs={12} nos dois, o Grid item do botão tomava 100% da largura → ele aparecia
              "esticado" mesmo sendo size="small", e a cor primária estava sendo morta pelo override
              global do mexx-global-override (corrigido no PaperProps.sx). */}
          <Grid className='omnichannel-chat-user-details-sidebar-header' item xs={5} sm={5} md={6} lg={6} xl={6} >
            {intl.formatMessage({ id: "chatdetails.notes" })}
          </Grid>
          <Grid className={`${classes.gridItemSubtitleColor}`} item xs={7} sm={7} md={6} lg={6} xl={6} style={{ display: 'flex', justifyContent: 'flex-end' }} >
            <Button variant="outlined"
              onClick={() => props.openOrCloseDialogAddNoteModal()}
              // `minWidth: 0` anula o piso de 64px do MUI Button; `padding: 4px 10px` aperta
              // o respiro interno. Sem isso, mesmo `size="small"` produz um botão ~107px
              // visualmente "gigante" num drawer mobile estreito. Mantém textTransform: none.
              style={{ textTransform: 'none', minWidth: 0, padding: '4px 10px' }}
              size="small" >
              {intl.formatMessage({ id: "chatdetails.addnote" })}
            </Button>
          </Grid>
          {props.chats && props.chats.chat && props.chats.chat.chatnotes && props.chats.chat.chatnotes.length > 0 ? props.chats.chat.chatnotes.map((entry, index) => (

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ marginTop: 5 }} >
                <ChatNote content={entry.description} attachments = {entry.chatnotesattachments} setLoading={props.setLoading} setNotificationMessage={props.setNotificationMessage} setNotificationVariant={props.setNotificationVariant} setOpenNotification={props.setOpenNotification} intl= {intl} />
            </Grid>

          ))
            : null
          }

        </Grid>
        </div>

        <RequesterHistoryDetailsModal
          open={!!calledDetailItem}
          onClose={closeCalledDetail}
          item={calledDetailItem}
          intl={intl}
          setMessage={(isOpen, variant, message) => {
            if (isOpen) {
              props.setNotificationMessage(message);
              props.setNotificationVariant(variant);
              props.setOpenNotification(true);
            }
          }}
        />
      </>
    );

    // ---- Wrapper externo: muda conforme viewport, conteúdo é o mesmo ----
    //
    // MOBILE (<600px):
    //   Drawer com variant="temporary" → overlay fullscreen com backdrop, fecha por
    //   clique fora ou ESC. Soluciona o `height: 116.5%` que vazava antes (drawer
    //   gerencia altura sozinho) e o `width: 30%` que espremia o conteúdo. O `maxWidth:
    //   380px` no Paper deixa a sidebar full-screen-ish sem ocupar 100% em landscape.
    //   `keepMounted` preserva o estado dos formulários internos (Controller do RHF)
    //   ao abrir/fechar, igual ao comportamento do desktop (que sempre renderiza).
    //
    // DESKTOP (>=600px):
    //   <div> com as classes.root/open originais, animação de width inalterada.
    //   Zero diff visual em relação ao código antes do refactor.
    if (isMobile) {
      return (
        <Drawer
          variant="temporary"
          anchor="right"
          open={isOpen}
          onClose={onClose}
          ModalProps={{ keepMounted: true }}
          PaperProps={{
            sx: {
              width: '100%',
              maxWidth: '380px',
              backgroundColor: '#F3F3F3',
              // Restaura cores naturais que o override global de `paperAnchorRight` mata.
              // Refinado por variant — outlined/text recebem verde primary, contained fica intacto
              // (global pinta branco que é EXATAMENTE o que queremos pro Save com bg verde),
              // IconButton dark gray.
              //
              // IMPORTANTE: uso `#8BC34A` hardcoded em vez de `var(--mexx-green-primary)` porque
              // a var é carregada DINAMICAMENTE por ThemeLoader.jsx só quando o hostname é
              // localhost ou .2do.homologa. Em produção (ou outros ambientes), a var fica
              // undefined e o `var()` resolve como invalid → property revert. Hex = à prova de balas.
              // O valor #8BC34A é o palette.primary.main exato do tema MUI (vide src/styles/palette.js).
              '& .MuiButton-outlined': {
                color: '#8BC34A !important',
                borderColor: '#8BC34A !important',
              },
              '& .MuiButton-text': {
                color: '#8BC34A !important',
              },
              '& .MuiIconButton-root': {
                color: 'rgba(0, 0, 0, 0.54) !important',
              },
            }
          }}
        >
          {/* <section> em vez de <div> de propósito: existe um override global em
              mexx-global-override.css `.MuiDrawer-paperAnchorRight > div:first-child`
              que força background verde + texto branco (feito pra outro Drawer da app).
              Trocando a tag pra section o seletor `> div:first-child` não casa mais,
              o Paper mantém o background claro (#F3F3F3) — sem precisar mexer na
              regra global que segue válida pros outros Drawers que dependem dela. */}
          <section className="omnichannel-chat-user-details-sidebar" style={{ width: '100%', height: '100%', overflow: 'hidden', display: 'flex', flexDirection: 'column', backgroundColor: '#F3F3F3' }}>
            {content}
          </section>
        </Drawer>
      );
    }

    return (
      <div className={`${classes.root} ${isOpen ? classes.open : ''} omnichannel-chat-user-details-sidebar`}>
        {content}
      </div>
    );
  } else {
    return (<></>)
  }
}

const mapStateToProps = state => ({
  chats: state.chats
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(componentActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ChatUserDetailsSidebar))
